import axios from 'axios';

const TOKEN = document.querySelector('meta[name="csrf-token"]').content;
const PAGE = 'special_equipments';

export default async function SpecialEquipment() {
  const url = new URL(window.location.href);

  const loadMoreBtn = document.querySelector('.equipment .loading-more-btn');
  const equipmentCardsList = document.querySelector('.equipment .equipment__card-list');

  const searchVariableForm = document.querySelector('.equipment .search-variable__form.form');
  const category = document.querySelector('.search-variable__form.form #category');
  const city = document.querySelector('.search-variable__form.form #city');

  const slug = url.pathname.split('/').filter((segment) => segment.length > 0).pop();
  const cityIdParam = url.searchParams.get('cityId');

  if (category && slug !== PAGE) {
    const categoryElement = document.getElementById(slug);
    category.textContent = categoryElement.textContent;
  }

  if (city && cityIdParam) {
    const cityElement = document.getElementById(cityIdParam);
    city.textContent = cityElement.textContent;
  }

  if (equipmentCardsList) {
    equipmentCardsList.setAttribute('data-page', 1);
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', async () => {
      const equipmentCardIds = Array.from(document.querySelectorAll('.equipment__card'))
        .map((card) => parseInt(card.getAttribute('data-id'), 10));
      const cityName = city.textContent.trim();
      const categoryName = category.textContent.trim();
      const { page } = equipmentCardsList.dataset;
      const newPage = parseInt(page, 10) + 1;

      const { data } = await loadMoreRequest('get-more-equipment', cityName, categoryName, page, equipmentCardIds);

      if (data.pageData === null) {
        loadMoreBtn.setAttribute('style', 'display: none;');
      } else {
        equipmentCardsList.insertAdjacentHTML('beforeend', data.pageData);
        if (data.isLastPage) {
          loadMoreBtn.setAttribute('style', 'display: none;');
        }
      }

      if (equipmentCardsList) {
        equipmentCardsList.setAttribute('data-page', newPage);
      }
    });
  }

  if (searchVariableForm) {
    searchVariableForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const categoryNameSelected = category.textContent.trim();
      let categorySlug = '/';

      const cityNameSelected = city.textContent.trim();
      let getParams = '';

      const categoryElementSelected = document.querySelector(`[data-category-name="${categoryNameSelected}"]`);
      if (categoryElementSelected) {
        categorySlug += `${categoryElementSelected.dataset.categorySlug}/`;
      }

      const cityElementSelected = document.querySelector(`[data-city-name="${cityNameSelected}"]`);
      if (cityElementSelected) {
        getParams += `?cityId=${cityElementSelected.dataset.cityId}`;
      }

      window.location.href = `/${PAGE}${categorySlug}${getParams}`;
    });

    searchVariableForm.addEventListener('reset', async (e) => {
      e.preventDefault();

      window.location.href = `/${PAGE}/`;
    });
  }
}

async function loadMoreRequest(route, cityName, categoryName, page, cardIds) {
  try {
    let cityId = '';
    const cityElementSelected = document.querySelector(`[data-city-name="${cityName}"]`);

    if (cityElementSelected) {
      cityId = cityElementSelected.dataset.cityId || '';
    }

    let categorySlug = '';
    const categoryElementSelected = document.querySelector(`[data-category-name="${categoryName}"]`);

    if (categoryElementSelected) {
      categorySlug = categoryElementSelected.dataset.categorySlug || '';
    }

    const { data } = await axios.get(`/api/${route}/`, {
      params: {
        cityId,
        categorySlug,
        page,
        cardIds: cardIds.join(','),
      },
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': TOKEN,
      },
    });

    return data;
  } catch (error) {
    return {
      data: [],
    };
  }
}
